<div class="px-4 my-4">
    <!-- Encabezado con título y botón de agregar -->
    <div class="flex flex-row flex-wrap justify-between items-center mb-4">
        <h3 class="m-0">Programa</h3>
        <button type="button" mat-raised-button color="primary" *ngIf="addPermission" (click)="openDialog()">
            Agregar programa
        </button>
    </div>

    <!-- Campo de búsqueda -->
    <mat-form-field class="w-full mb-4">
        <input matInput placeholder="Buscar..." autocomplete="off" [formControl]="searchForm">
    </mat-form-field>

    <!-- Tabla de datos -->
    <ngx-datatable [loadingIndicator]="loading" class="material min-h-[400px]" [messages]="messages" [columnMode]="'force'" [headerHeight]="45"
        [footerHeight]="45" [rowHeight]="100" [scrollbarV]="true" [scrollbarH]="true"
        [rows]="rows| search: searchForm.value:keys">

        <!-- Columna de id -->
        <ngx-datatable-column name="Id" prop="id" [width]="70" [canAutoResize]="false" [sortable]="false"
            [draggable]="false"></ngx-datatable-column>

        <!-- Columna de numeración -->
        <!-- <ngx-datatable-column name="id" [width]="50" [canAutoResize]="false" [sortable]="false" [draggable]="false">
            <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                <span class="pl-2">{{ rowIndex + 1 }}</span>
            </ng-template>
        </ngx-datatable-column> -->

        <!-- Columna de Nombre -->
        <ngx-datatable-column name="Nombre" prop="nombre" [width]="180">
            <ng-template let-value="value" ngx-datatable-cell-template>
                <span class="pl-2">{{ value }}</span>
            </ng-template>
        </ngx-datatable-column>

        <!-- Columna de Descripción -->
        <ngx-datatable-column name="Descripción" prop="descripcion" [width]="200">
            <ng-template let-value="value" ngx-datatable-cell-template>
                <span class="pl-2">{{ value }}</span>
            </ng-template>
        </ngx-datatable-column>

        <!-- Columna de Plataformas -->
        <ngx-datatable-column name="Plataformas" prop="programa_plataformas" [width]="200">
            <ng-template let-value="value" ngx-datatable-cell-template>
                <adp-platform-menu [items]="value"></adp-platform-menu>
            </ng-template>
        </ngx-datatable-column> 

        <!-- Columna de Acciones -->
        <ngx-datatable-column name="Acciones" [width]="150" [sortable]="false">
            <ng-template let-row="row" ngx-datatable-cell-template>
                <div class="flex justify-start items-center pl-2">
                    <button mat-stroked-button mat-button-sm color="primary" type="button" class="mr-2"
                        (click)="edit(row)" [matTooltip]="'Editar'">
                        <mat-icon>edit</mat-icon>
                    </button>
                    <!-- <button mat-stroked-button mat-button-sm type="button" *ngIf="editPermission" class="mr-2" (click)="link(row)">
                        <mat-icon>link</mat-icon>
                    </button> -->
                    <button mat-stroked-button mat-button-sm type="button" *ngIf="deletePermission"
                        (click)="delete(row.id)" [matTooltip]="'Eliminar'">
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>
            </ng-template>
        </ngx-datatable-column>

    </ngx-datatable>
</div>